var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { classes } from '../../helpers';
import { colStyle } from './style';
export const Col = React.forwardRef((props, ref) => {
    const { className, children, span: __span, spanSm: __spanSm, spanMd: __spanMd, spanLg: __spanLg, spanXl: __spanXl, spanXs: __spanXs } = props, rest = __rest(props, ["className", "children", "span", "spanSm", "spanMd", "spanLg", "spanXl", "spanXs"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: classes(className, colStyle(props), 'sha-el-col') }, rest), children));
});
Col.defaultProps = {
    span: 24,
};
//# sourceMappingURL=Col.js.map